import { OracleDowntimeScheduleDisplay } from './types';

/**
 * Check if an Oracle downtime schedule has started (START date check)
 * Used for delete eligibility: Can delete ONLY if schedule hasn't started yet
 * @param schedule - The schedule to check (or null/undefined)
 * @returns true if the schedule's start date/time has passed, false otherwise
 */
export const hasScheduleStarted = (schedule: OracleDowntimeScheduleDisplay | null | undefined): boolean => {
  if (!schedule) return false;
  return schedule.startDateTime.getTime() < new Date().getTime();
};

/**
 * Check if an Oracle downtime schedule can be edited (END date check)
 * @param schedule - The schedule to check (or null/undefined)
 * @returns true if the schedule can be edited (end date is future or null), false otherwise
 */
export const canEditSchedule = (schedule: OracleDowntimeScheduleDisplay | null | undefined): boolean => {
  if (!schedule) return false;
  // Can edit if end date is null (ongoing) OR end date is in the future
  if (schedule.endDateTime === null) return true;
  return schedule.endDateTime.getTime() > new Date().getTime();
};
